


































import Vue from 'vue'
import {
  IStatement,
  EStatementStatuses
} from '@zunta/configurations'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { StatementModule } from '@/store/modules/statement.module'
import { STATEMENTS_STORAGE_URL } from '@/constants'
import { ETableColumnType, ITableColumn, ITableConfig } from '@/interfaces'
import { User } from '@/classes/User'
import Api from '@/api'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'

@Component({
  components: {
    Table,
    Card,
    DateTimeLabel,
    Icon
  }
})
export default class ResidentStatementBlock extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  EStatementStatuses: any = EStatementStatuses
  user: User = Api.getUser() as User
  filters: any = {
    skip: 0,
    limit: 20
  }

  get config () {
    const config: ITableConfig = {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      usePagination: true,
      fetchFunction: this.fetchStatements,
      columns: [
        {
          minWidth: '150px',
          width: 30,
          key: 'recipient',
          searchKey: 'recipientName',
          hasSearch: true,
          label: 'Recipient',
          type: ETableColumnType.char
        },
        {
          headClass: 'bt-justify-content-end',
          class: 'text-right',
          minWidth: '140px',
          width: 30,
          key: 'due',
          searchKey: 'due',
          hasSearch: true,
          label: 'Due',
          type: ETableColumnType.numberRange
        },
        {
          class: 'text-center',
          minWidth: '120px',
          width: 30,
          key: 'billDate',
          searchKey: 'billDate',
          hasSearch: true,
          hasSort: true,
          label: 'Bill Date',
          type: ETableColumnType.dateRange
        },
        {
          class: 'text-right',
          minWidth: '50px',
          width: 10,
          key: 'actions'
        }
      ]
    }
    if (!this.isMobile) {
      return config
    }

    config.columns = config.columns.map((column: ITableColumn) => {
      return {
        ...column,
        hasSearch: false
      }
    })

    return config
  }

  get isMobile () {
    return window.innerWidth <= 768
  }

  get residentId () {
    return this.user.getResidents()[0]
  }

  get statementListTotal () {
    return this.$store.state.statement.statementListTotal
  }

  get statementList () {
    return this.$store.state.statement.statementList
  }

  async fetchStatements (filters: any) {
    await this.statementModuleInstance.getResidentStatementListByFilters({
      residentId: this.residentId,
      filters
    })
  }

  goStatementReview (statement: IStatement) {
    window.open(`${STATEMENTS_STORAGE_URL}?file=${statement.pdf}`)
  }

  beforeDestroy () {
    this.statementModuleInstance.resetStatementList()
  }
}
